var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelephone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.21,
    height: 25.211,
    viewBox: "0 0 25.21 25.211",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-25.098 -12.847)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.098 12.847)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M21.208,61.909a1.954,1.954,0,0,0-2.954,0c-.691.685-1.381,1.37-2.06,2.066a.407.407,0,0,1-.569.1c-.447-.244-.923-.441-1.352-.708a21.424,21.424,0,0,1-5.165-4.7A12.237,12.237,0,0,1,7.257,55.7a.425.425,0,0,1,.1-.546c.691-.667,1.364-1.352,2.043-2.037A1.962,1.962,0,0,0,9.4,50.1c-.54-.546-1.079-1.079-1.619-1.625-.557-.557-1.108-1.12-1.671-1.671a1.967,1.967,0,0,0-2.954.006c-.7.685-1.364,1.387-2.072,2.06A3.363,3.363,0,0,0,.026,51.138a9.614,9.614,0,0,0,.743,4.138A25.143,25.143,0,0,0,5.232,62.71a27.617,27.617,0,0,0,9.146,7.156,13.228,13.228,0,0,0,5.066,1.474,3.713,3.713,0,0,0,3.186-1.213c.592-.662,1.259-1.265,1.886-1.9a1.974,1.974,0,0,0,.012-3.006Q22.874,63.56,21.208,61.909Z",
    transform: "translate(-0.006 -46.137)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephone);
export default __webpack_public_path__ + "static/media/telephone.cbea58096a82095d4732c9ffeeed7bce.svg";
export { ForwardRef as ReactComponent };